import React, { Component } from "react";
import "./styles.css";

class DropdownCard extends Component {
  render() {
    const { title, options, value, onSelectionChange, disabled } = this.props;

    const isFreeResponse =
      options && options.length === 1 && options[0].type === "free-response";

    return (
      <div className="dropdown-card-container">
        <div className="card shadow-sm">
          <div className="card-header bg-primary text-white">
            <h5 className="mb-0">{title}</h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                {isFreeResponse ? (
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder={options[0].title}
                    value={value ?? ""}
                    onChange={e =>
                      onSelectionChange && onSelectionChange(e.target.value)
                    }
                    disabled={disabled}
                  />
                ) : (
                  <select
                    className="form-control"
                    value={value ?? ""}
                    onChange={e =>
                      onSelectionChange && onSelectionChange(e.target.value)
                    }
                    disabled={disabled}
                  >
                    <option value="">Selecione uma opção</option>
                    {options &&
                      options.map(option => (
                        <option key={option.id} value={option.id}>
                          {option.title}
                        </option>
                      ))}
                  </select>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DropdownCard;
